import { t } from 'i18next';
/////////////////////////////////////////////////////////////
import { TabImage } from '@/app/shared/components';
import { RouteType } from '../type';

import Dashboard from '@/app/pages/Dashboard';
import BattlePass from '@/app/pages/BattlePass';
import Build from '@/app/pages/Build';
import Friends from '@/app/pages/Friends';
import Earn from '@/app/pages/Earn';
import Airdrop from '@/app/pages/Airdrop';
import Settings from '@/app/pages/Settings';
import Hacks from '@/app/pages/Hacks';
import ChooseNetwork from '@/app/pages/ChooseNetwork';
import ChooseLanguage from '@/app/pages/ChooseLanguage';
import DailyReward from '@/app/pages/DailyReward';
import LevelStandings from '@/app/pages/LevelStandings';
import Roulette from '@/app/pages/Roulette';
import BattleDerbyAirdrop from '@/app/pages/BattleDerbyAirdrop';
import GroupsCollections from '@/app/pages/GroupsCollections';
import Collections from '@/app/pages/Collections';
import Stickers from '@/app/pages/Stickers';
import Shop from '@/app/pages/Shop';
import Skins from '@/app/pages/Skins';
import SkinPack from '@/app/pages/SkinPack';
import Wallet from '@/app/pages/Wallet';

const routesTypeApp: RouteType[] = [
	{
		index: true,
		id: 10101,
		element: <Dashboard />,
		isMenu: false,
		isMenuInsider: false,
		isComingSoon: false,
		path: '',
		icon: '',
		state: 'dashboard',
		sidebarProps: {
			displayText: 'dashboard',
		},
	},
	{
		id: 10102,
		element: <Build />,
		isMenu: true,
		isMenuInsider: false,
		isComingSoon: false,
		path: 'build',
		state: 'build',
		// icon: '',
		icon: (
			<TabImage
				image={process.env.VITE_TAB_TWO_IMAGE!}
				alt={t('nav.build')}
			/>
		),
		sidebarProps: {
			displayText: 'build',
		},
	},
	{
		id: 10103,
		element: <Friends />,
		isMenu: true,
		isMenuInsider: false,
		isComingSoon: false,
		path: 'friends',
		state: 'friends',
		icon: (
			<TabImage
				image={process.env.VITE_TAB_THREE_IMAGE!}
				alt={t('nav.frens')}
			/>
		),
		sidebarProps: {
			displayText: 'frens',
		},
	},
	{
		id: 10104,
		element: <Earn />,
		isMenu: true,
		isMenuInsider: false,
		isComingSoon: false,
		path: 'earn',
		state: 'earn',
		icon: (
			<TabImage
				image={process.env.VITE_TAB_FOUR_IMAGE!}
				alt={t('nav.earn')}
			/>
		),
		sidebarProps: {
			displayText: 'earn',
		},
	},

	{
		id: 10106,
		element: <Settings />,
		isMenu: false,
		isMenuInsider: true,
		isComingSoon: false,
		path: 'settings',
		state: 'settings',
		icon: '',
		sidebarProps: {
			displayText: 'settings',
		},
	},
	{
		id: 10107,
		element: <Hacks />,
		isMenu: false,
		isMenuInsider: false,
		isComingSoon: false,
		path: 'hacks',
		state: 'hacks',
		icon: '',
		sidebarProps: {
			displayText: 'hacks',
		},
	},
	{
		id: 10108,
		element: <ChooseNetwork />,
		isMenu: false,
		isMenuInsider: false,
		isComingSoon: false,
		path: 'settings/network',
		state: 'settings',
		icon: '',
		sidebarProps: {
			displayText: 'settings',
		},
	},
	{
		id: 10118,
		element: <ChooseLanguage />,
		isMenu: false,
		isMenuInsider: false,
		isComingSoon: false,
		path: 'settings/language',
		state: 'language',
		icon: '',
		sidebarProps: {
			displayText: 'language',
		},
	},
	{
		id: 10109,
		element: <DailyReward />,
		isMenu: false,
		isMenuInsider: false,
		isComingSoon: false,
		path: 'daily-rewards',
		state: 'daily',
		icon: '',
		sidebarProps: {
			displayText: 'daily-rewards',
		},
	},
	{
		id: 10110,
		element: <LevelStandings />,
		isMenu: false,
		isMenuInsider: false,
		isComingSoon: false,
		path: 'levels',
		state: 'levels',
		icon: '',
		sidebarProps: {
			displayText: 'levels',
		},
	},
];

if (process.env.VITE_APP_NAME === 'Vottun Dojo') {
	routesTypeApp.push({
		id: 10105,
		element: <Airdrop />,
		isMenu: true,
		isMenuInsider: false,
		isComingSoon: false,
		path: 'airdrop',
		state: 'airdrop',
		icon: (
			<TabImage
				image={process.env.VITE_TAB_FIVE_IMAGE!}
				alt={t('nav.airdrop')}
			/>
		),
		sidebarProps: {
			displayText: 'airdrop',
		},
	});
} else if (process.env.VITE_APP_NAME === 'Battle Derby') {
	routesTypeApp.push({
		id: 10105,
		element: <BattleDerbyAirdrop />,
		isMenu: true,
		isMenuInsider: false,
		isComingSoon: false,
		path: 'airdrop',
		state: 'airdrop',
		icon: (
			<TabImage
				image={process.env.VITE_TAB_FIVE_IMAGE!}
				alt={t('nav.airdrop')}
			/>
		),
		sidebarProps: {
			displayText: 'airdrop',
		},
	});
}

if (process.env.VITE_ENABLE_COLLECTIONS) {
	routesTypeApp.push({
		id: 11000,
		element: <GroupsCollections />,
		isMenu: false,
		isMenuInsider: true,
		isComingSoon: false,
		path: 'collections',
		state: 'collections',
		icon: '',
		sidebarProps: {
			displayText: 'collections',
		},
	});

	routesTypeApp.push({
		id: 11001,
		element: <Collections />,
		isMenu: false,
		isMenuInsider: false,
		isComingSoon: false,
		path: 'collections/:group',
		state: 'collections',
		icon: '',
		sidebarProps: {
			displayText: 'collections',
		},
	});

	routesTypeApp.push({
		id: 11002,
		element: <Stickers />,
		isMenu: false,
		isMenuInsider: false,
		isComingSoon: false,
		path: 'collections/:group/:collection',
		state: 'collection',
		icon: '',
		sidebarProps: {
			displayText: 'collection',
		},
	});
}

if (process.env.VITE_ENABLE_ROULETTE) {
	routesTypeApp.push({
		id: 11200,
		element: <Roulette />,
		isMenu: false,
		isMenuInsider: false,
		isComingSoon: false,
		path: 'roulette',
		state: 'roulette',
		icon: '',
		sidebarProps: {
			displayText: 'roulette',
		},
	});
}

if (process.env.VITE_ENABLE_WALLET) {
	routesTypeApp.push({
		id: 11300,
		element: <Wallet />,
		isMenu: false,
		isMenuInsider: true,
		isComingSoon: true,
		path: 'wallet',
		state: 'wallet',
		icon: '',
		sidebarProps: {
			displayText: 'wallet',
		},
	});
}

if (process.env.VITE_ENABLE_SKINS) {
	routesTypeApp.push({
		id: 11400,
		element: <Skins />,
		isMenu: false,
		isMenuInsider: true,
		isComingSoon: true,
		path: 'skins',
		state: 'skins',
		icon: '',
		sidebarProps: {
			displayText: 'skins',
		},
	});

	routesTypeApp.push({
		id: 11401,
		element: <SkinPack />,
		isMenu: false,
		isMenuInsider: true,
		isComingSoon: true,
		path: 'skins/:skinPackId',
		state: 'skinPack',
		icon: '',
		sidebarProps: {
			displayText: 'skinPack',
		},
	});
}

if (process.env.VITE_ENABLE_SHOP) {
	routesTypeApp.push({
		id: 11500,
		element: <Shop />,
		isMenu: false,
		isMenuInsider: true,
		isComingSoon: true,
		path: 'shop',
		state: 'shop',
		icon: '',
		sidebarProps: {
			displayText: 'shop',
		},
	});
}

if (process.env.VITE_ENABLE_BATTLEPASS) {
	routesTypeApp.push({
		id: 11600,
		element: <BattlePass />,
		isMenu: false,
		isMenuInsider: true,
		isComingSoon: true,
		path: 'battle-pass',
		state: 'battlePass',
		icon: '',
		sidebarProps: {
			displayText: 'battlePass',
		},
	});
}

export default routesTypeApp;
